import { render } from "./RegisterSmall.vue?vue&type=template&id=12d509aa&scoped=true"
import script from "./RegisterSmall.vue?vue&type=script&lang=js"
export * from "./RegisterSmall.vue?vue&type=script&lang=js"

import "./RegisterSmall.vue?vue&type=style&index=0&id=12d509aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d509aa"]])

export default __exports__